import React from 'react';
import EventBrellaLayout from './EventBrellaLayout';
import EventSpacesCalculator from '../../eventsCalculator/components/EventSpacesCalculator';

const EventBrellaCalculatorPage = () => (
  <EventBrellaLayout calculator>
    <EventSpacesCalculator />
  </EventBrellaLayout>
);

export default EventBrellaCalculatorPage;
